import { render, staticRenderFns } from "./advertise-list.vue?vue&type=template&id=81311ac8&"
import script from "./advertise-list.vue?vue&type=script&lang=js&"
export * from "./advertise-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports